
<template>
  <router-btn :text="$t('servicesystem.common_objects.commonterms.new')"
              :icon="'mdi-plus'"
              :color="'quaternary'"
              :disabled="false"
              :outlined="false"
              :textbtn="textbtn"
              :large="large"
              :small="small"
              @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "NewLoggBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  created() {},

  mounted() {},

  methods: {
    action() {
      this.$store.state.triggerevents.previewTrigger++;
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped>
</style>
